import {
  BOARD_SETTINGS_GET_ALL_DATA,
  SWAP_STAGE_ORDER,  
} from '../../actions/boardSettings';

export default function boardSettings(state = {}, action) {
    switch (action.type) {
        case BOARD_SETTINGS_GET_ALL_DATA:
          return Object.assign({}, state, action.payload);
        case SWAP_STAGE_ORDER:
          return Object.assign({}, state, action.payload);        
        default:
          return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/boardSettings/index.js